// extracted by mini-css-extract-plugin
module.exports = {"container":"FedorBusyScreen_container__LO8zc","title":"FedorBusyScreen_title__QduOA","text":"FedorBusyScreen_text___Up3r","button":"FedorBusyScreen_button__HiUJM"};